import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useSeo } from "@/lib/useSeo";
import { myProjects } from "@/lib/api";
import ProjectView from "@/components/ProjectView";

export default function Account() {
  useSeo({ title: "My Projects" });
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [loading, user, navigate]);

  useEffect(() => {
    if (user) myProjects().then(setProjects).catch(() => setProjects([]));
  }, [user]);

  if (!user) return <div className="pt-40 text-center text-ink/50">Loading…</div>;

  return (
    <div data-testid="account-page" className="pt-32 md:pt-40 pb-24 mx-auto max-w-[1100px] px-6 md:px-10">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-12">
        <div>
          <span className="overline text-bronze">Client Portal</span>
          <h1 className="font-display text-5xl mt-2 text-olive">Hello, {user.name || user.username}.</h1>
        </div>
        <button data-testid="account-logout" onClick={() => { logout(); navigate("/"); }}
          className="inline-flex items-center gap-2 border border-olive/30 text-olive px-5 py-3 rounded-sm text-sm uppercase tracking-[0.2em] font-bold hover:bg-olive hover:text-beige transition-colors">
          <LogOut size={15} /> Log out
        </button>
      </div>

      {projects === null ? (
        <p className="text-ink/50">Loading your projects…</p>
      ) : projects.length === 0 ? (
        <div data-testid="account-no-projects" className="bg-cream border border-olive/15 rounded-xl p-10 text-center">
          <h2 className="font-display text-3xl text-olive">No active project yet</h2>
          <p className="text-ink/65 text-lg mt-3 max-w-lg mx-auto">Once your project begins, your live progress, daily site photos, invoices and documents will appear here.</p>
          <Link to="/book-consultation" data-testid="account-book"
            className="mt-6 inline-flex items-center bg-olive text-beige text-sm uppercase tracking-[0.2em] font-bold px-8 py-4 rounded-sm hover:bg-[#21463c] transition-colors">
            Book Free Consultation
          </Link>
        </div>
      ) : (
        <div className="space-y-16">
          {projects.map((p) => <ProjectView key={p.id} project={p} />)}
        </div>
      )}
    </div>
  );
}
